// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type QuickAccessSearchQueryVariables = Types.Exact<{
  keyword: Types.Scalars['String']['input'];
}>;

export type QuickAccessSearchQuery = { __typename?: 'Query' } & {
  quickAccessSearch: Array<
    | ({ __typename?: 'QuickAccessSearchResultEmployee' } & Pick<
        Types.QuickAccessSearchResultEmployee,
        'id' | 'category' | 'uri'
      > & {
          employee: { __typename?: 'Employee' } & Pick<Types.Employee, 'status'> & {
              generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
                Types.EmployeeGeneralInformation,
                'preferredFullName'
              >;
            };
        })
    | ({ __typename?: 'QuickAccessSearchResultPage' } & Pick<
        Types.QuickAccessSearchResultPage,
        'name' | 'pageCategory' | 'uri' | 'category'
      >)
    | ({ __typename?: 'QuickAccessSearchResultPerformanceReview' } & Pick<
        Types.QuickAccessSearchResultPerformanceReview,
        'id' | 'category' | 'uri'
      > & {
          performanceReview: { __typename?: 'PerformanceReview' } & {
            employee: { __typename?: 'Employee' } & Pick<Types.Employee, 'id'> & {
                generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
                  Types.EmployeeGeneralInformation,
                  'preferredFullName'
                >;
              };
            period: { __typename?: 'PerformanceReviewPeriod' } & Pick<Types.PerformanceReviewPeriod, 'version'>;
            setting: { __typename?: 'PerformanceReviewSetting' } & Pick<Types.PerformanceReviewSetting, 'stage'>;
          };
        })
    | ({ __typename?: 'QuickAccessSearchResultProbationReview' } & Pick<
        Types.QuickAccessSearchResultProbationReview,
        'id' | 'category' | 'uri'
      > & {
          employee: { __typename?: 'Employee' } & {
            generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
              Types.EmployeeGeneralInformation,
              'preferredFullName'
            >;
            probationReview: Types.Maybe<
              { __typename?: 'ProbationReview' } & Pick<Types.ProbationReview, 'probationStatus'>
            >;
          };
        })
  >;
};

export const QuickAccessSearchDocument = /*#__PURE__*/ gql`
    query QuickAccessSearch($keyword: String!) {
  quickAccessSearch(keyword: $keyword) {
    category
    uri
    ... on QuickAccessSearchResultEmployee {
      id
      employee {
        status
        generalInformation {
          preferredFullName
        }
      }
    }
    ... on QuickAccessSearchResultPerformanceReview {
      id
      performanceReview {
        employee {
          id
          generalInformation {
            preferredFullName
          }
        }
        period {
          version
        }
        setting {
          stage
        }
      }
    }
    ... on QuickAccessSearchResultProbationReview {
      id
      employee {
        generalInformation {
          preferredFullName
        }
        probationReview {
          probationStatus
        }
      }
    }
    ... on QuickAccessSearchResultPage {
      name
      pageCategory
      uri
    }
  }
}
    `;

/**
 * __useQuickAccessSearchQuery__
 *
 * To run a query within a React component, call `useQuickAccessSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickAccessSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickAccessSearchQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useQuickAccessSearchQuery(
  baseOptions: Apollo.QueryHookOptions<QuickAccessSearchQuery, QuickAccessSearchQueryVariables> &
    ({ variables: QuickAccessSearchQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<QuickAccessSearchQuery, QuickAccessSearchQueryVariables>(QuickAccessSearchDocument, options);
}
export function useQuickAccessSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<QuickAccessSearchQuery, QuickAccessSearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<QuickAccessSearchQuery, QuickAccessSearchQueryVariables>(
    QuickAccessSearchDocument,
    options,
  );
}
// @ts-expect-error
export function useQuickAccessSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<QuickAccessSearchQuery, QuickAccessSearchQueryVariables>,
): Apollo.UseSuspenseQueryResult<QuickAccessSearchQuery, QuickAccessSearchQueryVariables>;
export function useQuickAccessSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<QuickAccessSearchQuery, QuickAccessSearchQueryVariables>,
): Apollo.UseSuspenseQueryResult<QuickAccessSearchQuery | undefined, QuickAccessSearchQueryVariables>;
export function useQuickAccessSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<QuickAccessSearchQuery, QuickAccessSearchQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<QuickAccessSearchQuery, QuickAccessSearchQueryVariables>(
    QuickAccessSearchDocument,
    options,
  );
}
export type QuickAccessSearchQueryHookResult = ReturnType<typeof useQuickAccessSearchQuery>;
export type QuickAccessSearchLazyQueryHookResult = ReturnType<typeof useQuickAccessSearchLazyQuery>;
export type QuickAccessSearchSuspenseQueryHookResult = ReturnType<typeof useQuickAccessSearchSuspenseQuery>;
